import Model from "@/models/Model";
import User from "@/models/User";

import {useJournalClassStore, useJournalClassesStore} from "@/stores/models/journal";
import AxiosClient from "@/apis/AxiosClient";

export default class JournalClass extends Model {
    resource() {
        return "journals";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }

    users() {
        return this.hasMany(User);
    }

    approve(payload){
        return this.$http.post(this.baseURL() + '/' + this.resource() + '/' + this.id + '/approve', payload);
    }

    exportProgressions() {
        return AxiosClient.put(
            this.baseURL() + '/journals/' + this.id + '/progressions',
            {
                columns: ['level','scheme','domain','year','dimension','subDimension','referenceNumber','statement', 'model_id'],
                externalUserProvider: 'seemis'
            }
        );
    }

    archive() {
        return this.$http.post(this.baseURL() + '/' + this.resource() + '/' + this.id + '/archive')
        .then(
            () => {
                const classStore = useJournalClassStore();
                const classesStore = useJournalClassesStore();
                classStore.patchItem(this.id, {archived_at: new Date()});
                classesStore.requestRefresh();
            },
            (err) => {
                throw new Error("Failed to archive journal class: " + err);
            }
        );
    }

    restore() {
        return this.$http.post(this.baseURL() + '/' + this.resource() + '/' + this.id + '/restore')
        .then(
            () => {
                const classStore = useJournalClassStore();
                const classesStore = useJournalClassesStore();
                classStore.patchItem(this.id, {archived_at: null, deleted_at: null});
                classesStore.requestRefresh();
            },
            (err) => {
                throw new Error("Failed to restore journal class: " + err);
            }
        );
    }

    delete() {
        return this.$http.delete(this.baseURL() + '/' + this.resource() + '/' + this.id)
        .then(
            () => {
                const classStore = useJournalClassStore();
                const classesStore = useJournalClassesStore();
                classStore.removeItem(this.id);
                classesStore.requestRefresh();
            },
            (err) => {
                throw new Error("Failed to delete journal class: " + err);
            }
        );
    }
}
